import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FAQTile from './FAQTile';
import KeyValueTile from './KeyValueTile';

import Guests from '../../../assets/images/onboard/give-guests-lots-2x.png';
import Essentials from '../../../assets/images/onboard/cover-the-essentials-2x.png';
import Honeymoon from '../../../assets/images/onboard/create-honeymoon-funds-2x.png';
import App from '../../../assets/images/onboard/download-our-top-rated-app-2x.png';

import MarthaAndrew1x from '../../../assets/images/onboard/Martha-Andrew_1x.png';
import MarthaAndrew2x from '../../../assets/images/onboard/Martha-Andrew_2x.png';
import CarolineSam1x from '../../../assets/images/onboard/Caroline-Sam_1x.png';
import CarolineSam2x from '../../../assets/images/onboard/Caroline-Sam_2x.png';
import JohnNate1x from '../../../assets/images/onboard/John-Nate_1x.png';
import JohnNate2x from '../../../assets/images/onboard/John-Nate_2x.png';

class BottomBlock extends Component {
  renderFAQHeader() {
    return (
      <div className="bottom-block__header-step-1">
        <h2>
          A Few Frequently Asked Questions
        </h2>
      </div>
    );
  }

  renderKeyValueHeader() {
    return (
      <div className="bottom-block__header-step-2">
        <h2>
          Top 4 Registry Hacks
        </h2>
        <p>What we’ve learned after working with over 500,000 couples and their guests.</p>
      </div>
    );
  }

  renderFAQContent() {
    return (
      <div className="bottom-block__content-step-1">
        <FAQTile
          header="Why should I register at Zola, not other stores?"
          content="Because we make it easy! We have the best gifts, top brands, and honeymoon funds all in one store. From our Registry Planner to our Thank-You Note Manager, our time-saving tools help you every step of the way."
        />
        <FAQTile
          header="What if I’m already registered at another store?"
          content="No problem. We'll import your registry to Zola and check if you've registered for any of the 50,000 gifts our store carries. Your guests will love the convenience of having all of your gifts in one place!"
        />
        <FAQTile
          header="What’s the easiest way to get started?"
          content="Our Registry Planner, which tells you how many gifts to add, is a great first step. Looking for the essentials? Use our Registry Checklist. For inspiration, browse other couples’ registries or new arrivals—we add 500 every week!"
        />
      </div>
    );
  }

  renderKeyValueContent() {
    return (
      <div className="bottom-block__content-step-2">
        <KeyValueTile
          className="key-value-tile__img-1"
          imageUrl={Guests}
          header="Give Guests Lots of Options"
          content="Add tons of gifts for them—you’ll even get 20% off remaining ones on your registry for six months after you say “I do.”"
        />
        <KeyValueTile
          className="key-value-tile__img-2"
          imageUrl={Essentials}
          header="Cover the Essentials"
          content="That pretty lamp is just as important as matching dishes. Don’t miss a beat with our definitive Registry Checklist."
        />
        <KeyValueTile
          className="key-value-tile__img-3"
          imageUrl={Honeymoon}
          header="Create Honeymoon Funds"
          content="Split up one large fund into several smaller ones. Guests are more inclined to contribute to specific experiences."
        />
        <KeyValueTile
          className="key-value-tile__img-4"
          imageUrl={App}
          header="Download Our Top-Rated App"
          content="Stay on top of your registry, get notified every time you get a gift, and be first to know about Zola news."
        />
      </div>
    );
  }

  renderCouplesQuotes() {
    return (
      <div>
        <div className="bottom-block__header-step-2">
          <h2>
            What Our Couples Have To Say
          </h2>
        </div>
        <div className="bottom-block__content-step-1 couple-quote-tile-container">
          <div className="couples-quote-tile">
            <img className="couple-image" src={MarthaAndrew1x} srcSet={`${MarthaAndrew2x} 2x`} alt="Couple" />
            <p>&ldquo;We were overwhelmed before we found Zola, but they made it <strong>easy from start to finish</strong>.&rdquo;</p>
            <div className="text-uppercase couple-name">Martha &amp; Andrew</div>
            <div className="couple-location">Washington, DC</div>
          </div>
          <div className="couples-quote-tile">
            <img className="couple-image" src={CarolineSam1x} srcSet={`${CarolineSam2x} 2x`} alt="Couple" />
            <p>&ldquo;The <strong>app was super helpful</strong>. And it was fun being notified every time we received a gift!&rdquo;</p>
            <div className="text-uppercase couple-name">Caroline &amp; Sam</div>
            <div className="couple-location">Topeka, KS</div>
          </div>
          <div className="couples-quote-tile">
            <img className="couple-image" src={JohnNate1x} srcSet={`${JohnNate2x} 2x`} alt="Couple" />
            <p>&ldquo;Very <strong>simple exchanges <em>and</em> free returns</strong>! We&apos;ve never had to lug gifts to the post office.&rdquo;</p>
            <div className="text-uppercase couple-name">John &amp; Nate</div>
            <div className="couple-location">Phoenix, AZ</div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { step } = this.props;
    // Optimizely adds window.addCoupleQuotesRegOnboard for testing.
    return (
      <div className="bottom-block__container">
        { step === 1 && this.renderFAQHeader() }
        { step === 1 && this.renderFAQContent() }
        { step === 2 && window.addCoupleQuotesRegOnboard && this.renderCouplesQuotes() }
        { step === 2 && !window.addCoupleQuotesRegOnboard && this.renderKeyValueHeader() }
        { step === 2 && !window.addCoupleQuotesRegOnboard && this.renderKeyValueContent() }
      </div>
    );
  }
}

BottomBlock.propTypes = {
  step: PropTypes.number
};

export default BottomBlock;



// WEBPACK FOOTER //
// ./src/components/onboard/registryOnboardComponents/BottomBlock.jsx